import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export const Positioning = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="relative">
      {/* Top divider */}
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div className="max-w-[1180px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px]">
        <div
          ref={ref}
          className={`max-w-[700px] transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <p className="text-[clamp(20px,3vw,26px)] font-normal leading-[1.55] text-[#0A0A0A]">
            We don't believe in branding for aesthetics.
            <br />
            <span className="text-[rgba(10,10,10,0.4)]">
              We believe in clarity before creativity.
            </span>
          </p>

          <p className="mt-8 text-[clamp(16px,2vw,18px)] leading-[1.65] text-[rgba(10,10,10,0.5)]">
            The Fussed Bulb partners with founders to define positioning,
            sharpen messaging, and build identities rooted in strategy, not
            trends.
          </p>
        </div>
      </div>
    </section>
  );
};
